<div class="jumbotron text-center content-height-custom" >
   <p *ngIf="loading==true"><i class="fa fa-circle-o-notch fa-spin" style="font-size:70px"></i></p> 
    <h1>Email Verification</h1>
    <p>{{verificationMsg}}</p>
</div>